import {ShippingForm} from "./ShippingForm";
import {useEffect, useState} from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import {useCookies} from "react-cookie";
import {PacksModal} from "../Modal/PacksModal";

export const CreateShipping = () => {
    const [response,setResponse]=useState(null);
    const [status,setStatus]=useState(true);
    const [packId,setPackId]=useState(undefined);
    const [packs,setPacks]=useState(undefined);
    const [modal,setModal]=useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();

    const changePackId = (e) => {
        setPackId(e.target.value);
    }
    const changeStatus = (e) => {
      setStatus(e.target.checked);
    }
    const openModal = () => {
      setModal(true);
    }
    useEffect(() => {
        getPacks();
    }, []);
    const getPacks = (n = 1) => {
        const url = Constants.apiUrl + "/api/packs/paginate?page=" + n;
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setPacks(r.data);
            })
            .catch((e) => {

            });
    }
    const create = () => {
        const url = Constants.apiUrl + "/api/shipping/create";
        axios.post(url, {
            status: status,
            pack_id: packId,
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setResponse(true);
        }).catch((e) => {
            setResponse(false);
        });
    }
    const searchPack = (query) => {
        if (query == "")
            getPacks();
        else
            searchPackApi(query);
    }
    const searchPackApi = (query) => {
        const url = Constants.apiUrl + "/api/packs/search" ;
        axios.post(url, {
            text: query,
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setPacks(r.data)
        }).catch((e) => {
        });
    }
    return (
        <>
            {response==true && <div className={"alert alert-success text-center"}>عملبات با موفقیت انجام شد</div>}
            {response==false && <div className={"alert alert-danger text-center"}>عملبات با شکست روبرو شد</div>}

            <ShippingForm
                type={"create"}
                action={create}
                status={status}
                packId={packId}
                modal={openModal}
                changeStatus={changeStatus}/>

            {modal &&
                <PacksModal
                    get={(n) => { getPacks(n) }}
                    packs={packs}
                    select={(e) => { setPackId(e);setModal(false)}}
                    search={(e)=>searchPack(e)}
                    close={()=>{setModal(false);} }

                />}
        </>
    )
}
